import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";
import type { DisplayType } from "../../../lib/types/enums/displayTypeEnum";

export type KeyFavoritesProps = { displayType: DisplayType };

export const keyFavorites: BaseKeyFunction<KeyFavoritesProps> = ({
  displayType,
}) => ["favorites", { displayType }];
